import { Service } from '@angular/core';
import { AbstractSearchService } from './abstract-search.service';
import { HighlightChannel } from './highlight.channels';

@Service()
export class HighlightService extends AbstractSearchService<HighlightChannel> {}
